var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centered"},[_c('sui-button',{attrs:{"fluid":"","icon":"download","label-position":"left","content":"Download Your Journey Data"},on:{"click":function($event){return _vm.exportCsv()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }